import React from "react";
import ReactDOM from "react-dom/client";

import LartonyApp from './LartonyApp';
import * as serviceWorker from './registerServiceWorker';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LartonyApp/>
);

serviceWorker.unregister();
